// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2023 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';

const schema = {
  $id: '/forgot-password-request-schema',
  type: 'object',
  required: ['targetUrl', 'email'],
  properties: {
    targetUrl: {
      type: 'string',
      minLength: 1,
    },
    email: {
      type: 'string',
      format: 'email',
      minLength: 1,
    },
  },
} as IJSONSchema;

export default schema;
